import { NgModule } from '@angular/core';

import { AlphanumericsOnlyDirective } from 'app/b2b-order/directives/alphanumerics-only.directive';
import { NoLeadingZeroDirective } from 'app/b2b-order/directives/no-leading-zero.directive';
import { NumbersOnlyDirective } from 'app/b2b-order/directives/numbers-only.directive';
import { RepeatDoneDirective } from 'app/b2b-order/directives/repeat-done.directive';
import { DecimalNumbersDirective } from 'app/smart-replenishment/directives/decimal-numbers.directive';
import { EnterDirective } from 'app/smart-replenishment/directives/enter.directive';
import { InvisibleDirective } from './invisible.directive';
import { NgLetDirective } from './ng-let.directive';
import { UserPrivilegesDirective } from './user-privileges.directive';
import { ZoomDirective } from './zoom.directive';

const directives = [
    RepeatDoneDirective,
    UserPrivilegesDirective,
    NumbersOnlyDirective,
    AlphanumericsOnlyDirective,
    InvisibleDirective,
    NgLetDirective,
    ZoomDirective,
    NoLeadingZeroDirective,
    DecimalNumbersDirective,
    EnterDirective
];

@NgModule({
    declarations: directives,
    exports: directives
})
export class DirectivesModule {}
